/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Note_Share_CtaInputs */

const en_note_share_cta = /** @type {(inputs: Note_Share_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Found this useful? Share!`)
};

const ar_note_share_cta = /** @type {(inputs: Note_Share_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل كان مفيدًا؟ شاركه!`)
};

const bn_note_share_cta = /** @type {(inputs: Note_Share_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লেখাটা কাজে লাগলে শেয়ার করুন!`)
};

const de_note_share_cta = /** @type {(inputs: Note_Share_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilfreich? Teile den Artikel!`)
};

const es_note_share_cta = /** @type {(inputs: Note_Share_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Te resultó útil? ¡Compartir!`)
};

const fr_note_share_cta = /** @type {(inputs: Note_Share_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez trouvé cela utile ? Partager!`)
};

const pt_note_share_cta = /** @type {(inputs: Note_Share_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achou isso útil? Compartilhar!`)
};

const zh_note_share_cta = /** @type {(inputs: Note_Share_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`觉得这有用吗？分享！`)
};

const tr_note_share_cta = /** @type {(inputs: Note_Share_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bunu yararlı buldunuz mu? Paylaşmak!`)
};

const ru_note_share_cta = /** @type {(inputs: Note_Share_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нашли это полезным? Делиться!`)
};

const pl_note_share_cta = /** @type {(inputs: Note_Share_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uznałeś to za przydatne? Udział!`)
};

/**
* | output |
* | --- |
* | "Found this useful? Share!" |
*
* @param {Note_Share_CtaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const note_share_cta = /** @type {((inputs?: Note_Share_CtaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Share_CtaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_note_share_cta(inputs)
	if (locale === "bn") return bn_note_share_cta(inputs)
	if (locale === "de") return de_note_share_cta(inputs)
	if (locale === "es") return es_note_share_cta(inputs)
	if (locale === "fr") return fr_note_share_cta(inputs)
	if (locale === "pt") return pt_note_share_cta(inputs)
	if (locale === "zh") return zh_note_share_cta(inputs)
	if (locale === "tr") return tr_note_share_cta(inputs)
	if (locale === "ru") return ru_note_share_cta(inputs)
	if (locale === "pl") return pl_note_share_cta(inputs)
	return en_note_share_cta(inputs)
});